<template>
  <b-card
    title="จัดการกลุ่มลูกค้า"
    no-body
  >
    <b-card
      no-body
    >
      <b-card-body>
        <!-- <div class="d-flex justify-content-between  flex-wrap"> -->
        <b-form @submit.prevent>
          <b-row>
            <!-- submit and reset -->
            <b-col>
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                type="submit"
                variant="info"
                class="mr-1"
                @click="addnewMemberGroup()"
              >
                เพิ่มกลุ่มลูกค้าใหม่
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </b-card-body>
    </b-card>
    <b-table
      ref="memberGroupTable"
      striped
      hover
      responsive
      class="position-relative"
      :busy.sync="isBusy"
      :per-page="tableQuery.page_size"
      :current-page="tableQuery.page"
      :items="fetchMemberGroups"
      :fields="fields"
    >
      <template #cell(active)="data">
        <b-badge :variant="{1:'light-success', 0:'light-primary'}[data.item.active]">
          {{ {1:'เปิดใช้งาน', 0:'ปิดการทำงาน'}[data.item.active] }}
        </b-badge>
      </template>
      <template #cell(btns)="data">
        <div style="text-align:center;">
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="outline-info"
            size="sm"
            @click="editMemberGroup(data.item)"
          >
            <feather-icon
              icon="EditIcon"
              class="mr-50"
            />
            แก้ไขข้อมูล
          </b-button>{{ ' ' }}
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="outline-danger"
            size="sm"
            @click="deleteMemberGroup(data.item)"
          >
            <feather-icon
              icon="MinusIcon"
              class="mr-50"
            />
            ลบ
          </b-button>
        </div>
      </template>

    </b-table>

    <b-card-body class="d-flex justify-content-between flex-wrap pt-0">

      <!-- page length -->
      <b-form-group
        label="Per Page"
        label-cols="6"
        label-align="left"
        label-size="sm"
        label-for="sortBySelect"
        class="text-nowrap mb-md-0 mr-1"
      >
        <b-form-select
          id="perPageSelect"
          v-model="tableQuery.page_size"
          size="sm"
          inline
          :options="pageOptions"
        />
      </b-form-group>

      <!-- pagination -->
      <div>
        <b-pagination
          v-model="tableQuery.page"
          :total-rows="totalRows"
          :per-page="tableQuery.page_size"
          first-number
          last-number
          prev-class="prev-item"
          next-class="next-item"
          class="mb-0"
        >
          <template #prev-text>
            <feather-icon
              icon="ChevronLeftIcon"
              size="18"
            />
          </template>
          <template #next-text>
            <feather-icon
              icon="ChevronRightIcon"
              size="18"
            />
          </template>
        </b-pagination>
      </div>
    </b-card-body>
  </b-card>
</template>

<script>
// import BCardCode from '@core/components/b-card-code/BCardCode.vue'
import {
  BCard, BTable, BBadge, BFormGroup, BFormSelect, BPagination, BButton, BCardBody, BCol, BRow, BForm,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import Cleave from 'vue-cleave-component'
import moment from 'moment'

export default {
  components: {
    BCard,
    BTable,
    BBadge,
    BFormGroup,
    BFormSelect,
    BPagination,
    // Cleave,
    // BInputGroup,
    // BFormInput,
    // BInputGroupAppend,
    BButton,
    BCardBody,
    BRow,
    BCol,
    BForm,
    // // vSelect,
    // flatPickr,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      isBusy: false,
      pageOptions: [100, 200, 500, 1000],
      totalRows: 1,
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      tableQuery: {
        page: 1,
        page_size: 100,
      },
      infoModal: {
        id: 'info-modal',
        title: '',
        content: '',
      },
      fields: [
        {
          key: 'id', label: 'Group ID', tdClass: 'text-center', thClass: 'text-center',
        },
        { key: 'name', label: 'ชื่อกลุ่ม', thClass: 'text-center' },
        {
          key: 'member_count', label: 'จำนวนสมาชิก', thClass: 'text-center', tdClass: 'text-center',
        },
        { key: 'btns', label: 'ดำเนินการ', thClass: 'text-center' },
      ],
      /* eslint-disable global-require */
      items: [
      ],
      /* eslint-disable global-require */
      status: [{
        1: 'Current', 2: 'Professional', 3: 'Rejected', 4: 'Resigned', 5: 'Applied',
      },
      {
        1: 'light-primary', 2: 'light-success', 3: 'light-danger', 4: 'light-warning', 5: 'light-info',
      }],
      promotionEventMaps: {},
    }
  },
  computed: {
    // getBankOptions() {
    //   return this.bankListOptions
    // },
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => ({ text: f.label, value: f.key }))
    },
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.items.length
    // this.fetchMember()
  },
  methods: {
    searchMember() {
      this.$refs.memberGroupTable.refresh()
    },
    clearSearch() {
      this.tableQuery = {
        page: 1,
        page_size: 100,
      }
      this.$refs.memberGroupTable.refresh()
    },
    deleteMemberGroup(data) {
      this.$swal({
        title: 'ยืนยันการลบกลุ่มลูกค้า?',
        text: `คุณกำลังจะยืนยันการลบกลุ่มลูกค้า ${data.name} ใช่ไหม การลบกลุ่มลูกค้าทำให้ลูกค้าในกลุ่มดังกล่าว จะย้ายไปเป็นกลุ่มเริ่มต้นให้อัตโมมัติ`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'ใช่ ตกลง',
        customClass: {
          confirmButton: 'btn btn-info',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value)
          return this.$http.delete(`users/groups/${data.id}`)
        return { data: { success: false } }
      }).then(({ data: updateResult }) => {
        if (updateResult.success) {
          this.$swal({
            icon: 'success',
            title: 'ลบกลุ่มลูกค้า',
            text: 'ลบกลุ่มลูกค้าเรียบร้อย',
            customClass: {
              confirmButton: 'btn btn-success',
            },
          })
          this.$refs.memberGroupTable.refresh()
        }
      }).catch(err => {
        this.$bvToast.toast(`เกิดข้อผิดพลาด | ${err}`, {
          variant: 'danger',
          title: 'ยืนยันการลบกลุ่มลูกค้าไม่สำเร็จ',
          toaster: 'b-toaster-bottom-right',
          solid: true,
          appendToast: false,
        })
      })
    },
    async fetchMemberGroups(ctx) {
      const { data: { member_groups } } = await this.$http.get('users/groups')
      // eslint-disable-next-line camelcase
      this.items = member_groups
      this.totalRows = member_groups.length
      // this.promotionEventMaps = promotionEvents
      return this.items
    },
    editMemberGroup(data) {
      console.log('editMemberGroup', data)
      this.$router.push({ name: 'manage-member-group-detail', params: { groupId: data.id } })
    },
    addnewMemberGroup() {
      this.$router.push({ name: 'manage-member-group-detail-add' })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
<style scoped>
.text-center {
  text-align: center;
}
</style>
